// src/utils/parseSRT.ts

export interface CaptionCue {
  start: number; // in seconds
  end: number;   // in seconds
  text: string;
}

export function parseSRT(srt: string): CaptionCue[] {
  const cues: CaptionCue[] = [];

  const blocks = srt.split(/\r?\n\r?\n/);
  for (const block of blocks) {
    const lines = block.trim().split(/\r?\n/);
    if (lines.length >= 2) {
      const timeMatch = lines[1].match(
        /(\d{2}):(\d{2}):(\d{2}),(\d{3})\s-->\s(\d{2}):(\d{2}):(\d{2}),(\d{3})/
      );
      if (!timeMatch) continue;

      const start =
        parseInt(timeMatch[1]) * 3600 +
        parseInt(timeMatch[2]) * 60 +
        parseInt(timeMatch[3]) +
        parseInt(timeMatch[4]) / 1000;

      const end =
        parseInt(timeMatch[5]) * 3600 +
        parseInt(timeMatch[6]) * 60 +
        parseInt(timeMatch[7]) +
        parseInt(timeMatch[8]) / 1000;

      const text = lines.slice(2).join(" ").replace(/\s+/g, " ").trim();

      cues.push({ start, end, text });
    }
  }

  return cues;
}